import { render, staticRenderFns } from "./SideBarTop.vue?vue&type=template&id=499607bb&scoped=true&"
import script from "./SideBarTop.vue?vue&type=script&lang=js&"
export * from "./SideBarTop.vue?vue&type=script&lang=js&"
import style0 from "./SideBarTop.vue?vue&type=style&index=0&id=499607bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499607bb",
  null
  
)

export default component.exports